import React from 'react';
import BrainLogo from './BrainLogo';
import { NAV_LINKS } from '../data/siteData';

export default function Footer() {
  const year = new Date().getFullYear();

  const handleNav = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer aria-label="Site footer">
      <div className="ft-wrap">
        {/* Brand column */}
        <div className="fc-brand">
          <div style={{ display: 'flex', alignItems: 'center', gap: '.55rem' }}>
            <BrainLogo id="ft" size={42} />
            <div>
              <div style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 900, fontSize: '1rem', color: '#fff', letterSpacing: '-.02em' }}>
                JSDevBrains<span style={{ color: 'var(--g)' }}>.</span>
              </div>
              <div style={{ fontSize: '.58rem', color: 'rgba(255,255,255,.35)', fontWeight: 600, letterSpacing: '.04em' }}>
                DIGITAL PVT LTD
              </div>
            </div>
          </div>
          <p className="fb-desc">
            Building the Intelligent Future — AI Agents, Cloud Consulting, and Digital Transformation from Thanjavur, India to the world.
          </p>
          <div className="fb-addr">
            SR Complex 36/1c Pkt Road<br />
            Thiruchitrambalam, Thanjavur<br />
            Tamil Nadu 614628, India
          </div>
          <div className="ft-soc">
            {[
              { href: 'https://linkedin.com/company/jsdevbrains', label: 'LinkedIn', text: 'in' },
              { href: '#', label: 'X', text: '𝕏' },
              { href: '#', label: 'GitHub', text: '⌨' },
              { href: '#', label: 'Instagram', text: '📷' },
              { href: 'https://wa.me/918123629993', label: 'WhatsApp', text: '💬' },
            ].map((s) => (
              <a key={s.label} href={s.href} className="fsc" target="_blank" rel="noopener noreferrer" aria-label={s.label} title={s.label}>
                {s.text}
              </a>
            ))}
          </div>
        </div>

        {/* Pages */}
        <div className="fc-col">
          <h4>Pages</h4>
          <ul>
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={(e) => handleNav(e, link.href)}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="fc-col">
          <h4>Services</h4>
          <ul>
            {['AI Agent Development', 'Cloud Consulting', 'Digital Transformation', 'Flutter & React Apps', '.NET Backend', 'DevSecOps'].map((s) => (
              <li key={s}><a href="#services" onClick={(e) => handleNav(e, '#services')}>{s}</a></li>
            ))}
          </ul>
        </div>

        {/* Products */}
        <div className="fc-col">
          <h4>Products</h4>
          <ul>
            <li><a href="#products" onClick={(e) => handleNav(e, '#products')}>🧠 DevBrains <span style={{ fontSize: '.62rem', color: 'var(--g)', fontWeight: 800 }}>(Sep 2026)</span></a></li>
            <li><a href="#products" onClick={(e) => handleNav(e, '#products')}>🛒 BuyAndSell <span style={{ fontSize: '.62rem', color: '#D97706', fontWeight: 800 }}>(2026)</span></a></li>
            <li><a href="#products" onClick={(e) => handleNav(e, '#products')}>🏘️ NeighbourPro <span style={{ fontSize: '.62rem', color: '#0891B2', fontWeight: 800 }}>(2026)</span></a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="fc-col">
          <h4>Contact</h4>
          <ul>
            <li><a href="tel:+918123629993">📞 +91 81236 29993</a></li>
            <li><a href="mailto:hello@jsdevbrains.com">✉️ hello@jsdevbrains.com</a></li>
            <li><a href="https://wa.me/918123629993" target="_blank" rel="noopener noreferrer">💬 WhatsApp Us</a></li>
            <li><a href="#internship" onClick={(e) => handleNav(e, '#internship')}>🎓 Internships</a></li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="ft-bot">
        <span>© {year} JSDevBrains Digital Private Limited. All rights reserved.</span>
        <span style={{ display: 'flex', gap: '1.2rem' }}>
          <a href="#home" onClick={(e) => handleNav(e, '#home')}>Privacy Policy</a>
          <a href="#home" onClick={(e) => handleNav(e, '#home')}>Terms of Service</a>
          <a href="https://wa.me/918123629993" target="_blank" rel="noopener noreferrer">Sitemap</a>
        </span>
      </div>
    </footer>
  );
}
